import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["mediaClientConfig"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { MediaClient } from '../client/media-client';
var NO_FLAGS = 'NO_FLAGS';
var mediaClientsMap = new Map();
export var getMediaClient = function getMediaClient(mediaClientConfig, featureFlags) {
  var _mediaClientsMap$get;
  var flagsMapKey = featureFlags || NO_FLAGS;
  var mediaClient = (_mediaClientsMap$get = mediaClientsMap.get(mediaClientConfig)) === null || _mediaClientsMap$get === void 0 ? void 0 : _mediaClientsMap$get.get(flagsMapKey);
  if (!mediaClient) {
    var subMap = mediaClientsMap.get(mediaClientConfig);
    if (!subMap) {
      subMap = new Map();
      mediaClientsMap.set(mediaClientConfig, subMap);
    }
    mediaClient = new MediaClient(mediaClientConfig, featureFlags);
    subMap.set(flagsMapKey, mediaClient);
  }
  return mediaClient;
};
var createEmptyMediaClient = function createEmptyMediaClient(featureFlags) {
  var emptyConfig = {
    authProvider: function authProvider() {
      return Promise.resolve({
        clientId: '',
        token: '',
        baseUrl: ''
      });
    }
  };
  return new MediaClient(emptyConfig, featureFlags);
};
export var withMediaClient = function withMediaClient(Component, featureFlags) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);
    var _super = _createSuper(_class);
    function _class() {
      _classCallCheck(this, _class);
      return _super.apply(this, arguments);
    }
    _createClass(_class, [{
      key: "render",
      value: function render() {
        // TODO MPT-315: clean up after we move mediaClientConfig into FileIdentifier
        var _this$props = this.props,
          mediaClientConfig = _this$props.mediaClientConfig,
          otherProps = _objectWithoutProperties(_this$props, _excluded);
        var mediaClient = !mediaClientConfig ? createEmptyMediaClient(featureFlags) : getMediaClient(mediaClientConfig, featureFlags);
        return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
          mediaClient: mediaClient
        }));
      }
    }]);
    return _class;
  }(React.Component);
};